import styled from 'styled-components';

export default styled.h1`
  font-size: 28px;
  height: 38px;
  line-height: 38px;
`;
